// extracted by mini-css-extract-plugin
export default {"xs":"375","sm":"576","md":"768","lg":"992","xl":"1200","xxl":"1440","fhd":"1921"};